import { normalizeCurrencyCode } from "../currency/currency.ts";

export const AUTOSAVE_INTERVAL_MS = 3 * 60 * 1000;

export function financialSaveInputs(value: {
  packagePriceEnabled: boolean | number; packagePriceMinor: number | null;
  taxMode: string; taxRate: number; currencyCode: string; exchangeRateBaseCurrency: string;
  exchangeRate: number; exchangeRateSource: string; exchangeRateUpdatedAt: number | null;
}) {
  return {
    discountType: "none", discountValue: 0,
    packagePriceEnabled: value.packagePriceEnabled === true || value.packagePriceEnabled === 1,
    packagePriceMinor: value.packagePriceMinor ?? 0,
    taxMode: value.taxMode, taxRate: Number(value.taxRate),
    currencyCode: normalizeCurrencyCode(value.currencyCode),
    exchangeRateBaseCurrency: normalizeCurrencyCode(value.exchangeRateBaseCurrency),
    exchangeRate: Number(value.exchangeRate) || 1,
    exchangeRateSource: value.exchangeRateSource || "manual",
    exchangeRateUpdatedAt: value.exchangeRateUpdatedAt ?? null,
  };
}

export function serializeSaveSnapshot(value: unknown): string {
  return JSON.stringify(sortSerializableValue(value));
}

export function hasUnsavedChanges(savedSnapshot: string, currentSnapshot: string): boolean {
  return savedSnapshot !== currentSnapshot;
}

function sortSerializableValue(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(sortSerializableValue);
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .sort(([left], [right]) => left.localeCompare(right))
        .map(([key, entry]) => [key, sortSerializableValue(entry)]),
    );
  }

  return value;
}
